'use client'

import { useCallback, useContext, useMemo } from 'react'

import { useSession } from 'next-auth/react'

import { getMarketSAP } from '@/helpers/getMarketSAP'
import { getRequestSiteContext } from '@/helpers/getRequestSiteContext'
import { useTenant } from '@/hooks/useTenant'
import { SiteContext } from '@/providers/SiteContextProvider'

export function useSiteContext() {
  const { siteContext, setSiteContext, isSet } = useContext(SiteContext)
  const { data: session } = useSession()
  const tenant = useTenant()

  const getBaseSiteId = useCallback(
    () => getMarketSAP(tenant.id, getRequestSiteContext(tenant, session, undefined, siteContext)),
    [session, tenant, siteContext]
  )

  return useMemo(
    () => ({
      getBaseSiteId,
      siteContext,
      setSiteContext,
      isSet,
    }),
    [getBaseSiteId, siteContext, setSiteContext, isSet]
  )
}
